import { format, isValid, parseISO } from 'date-fns';

/**
 * Format an ISO date/datetime string as DD/MM/YYYY. Returns '' for empty input
 * and the original string when unparseable, so a render never throws.
 */
export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const parsed = parseISO(value);
  if (!isValid(parsed)) {
    return value;
  }

  return format(parsed, 'dd/MM/yyyy');
}

/**
 * Format an ISO datetime string as "dd MMM yyyy, HH:mm" (e.g. "30 Jun 2026,
 * 17:43"). Follows the same fallback convention as {@link formatDate}: empty
 * input returns '', unparseable input returns the raw string.
 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const parsed = parseISO(value);
  if (!isValid(parsed)) {
    return value;
  }

  return format(parsed, 'dd MMM yyyy, HH:mm');
}
